import { SBase, SContainerFixed, SContainerInline } from './BigFloatButton.styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type BigFloatButtonProps = {
  tx: string;
  link?: string;
  onClick?: () => void;
  color?: 'yellow' | 'red' | 'blue-outlined';
  className?: string | undefined;
  disabled?: boolean;
  scrollableBackground?: boolean;
  position?: 'level-0' | 'level-1' | 'level-2';
  /** Use inside a parent that handles position (e.g. fixed sidebar footer). */
  inline?: boolean;
};

const BigFloatButton = ({
  tx,
  link,
  onClick,
  position = 'level-1',
  color,
  className,
  disabled,
  scrollableBackground = true,
  inline = false,
}: BigFloatButtonProps) => {
  const { t } = useTranslation();

  const inner =
    link != null ? (
      <SBase
        className={className}
        as={Link}
        to={link}
        color={color}
        role="button"
        data-e2e={`${tx}_button`}
      >
        {t(tx)}
      </SBase>
    ) : (
      <SBase
        className={className}
        as="button"
        onClick={onClick}
        color={color}
        disabled={disabled ?? false}
        role="button"
        data-e2e={`${tx}_button`}
      >
        {t(tx)}
      </SBase>
    );

  if (inline) {
    return <SContainerInline>{inner}</SContainerInline>;
  }

  return (
    <SContainerFixed $scrollableBackground={scrollableBackground} $position={position}>
      {inner}
    </SContainerFixed>
  );
};

export default BigFloatButton;
